module.exports = {
  bancontact: 'Bancontact',
  creditCard: 'Credit/Debt card',
  sofort: 'Sofort',
  iDeal: 'iDeal',
  giropay: 'GiroPay',
  eps: 'EPS'
};